export default __webpack_public_path__ + "static/media/US_Text4.4563a062.png";